// extracted by mini-css-extract-plugin
export var lg = "_i2-7";
export var md = "_i2-6";
export var placeholderContainer = "_i2-1";
export var placeholderIcon = "_i2-2";
export var productImage = "_i2-0";
export var sm = "_i2-5";
export var xl = "_i2-8";
export var xs = "_i2-4";
export var xxs = "_i2-3";